import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from '../ui';
import { TRAVEL_PROMO } from '../../data/home';

export default function TravelPromo() {
  const { t } = useTranslation();
  return (
    <div className="promo card">
      <h3 className="promo__title">{t(TRAVEL_PROMO.title)}</h3>
      <p className="promo__sub">{t(TRAVEL_PROMO.sub)}</p>
      <ul className="promo__list">
        {TRAVEL_PROMO.items.map((it) => (
          <li key={it.label}><span className="promo__ring"><Icon name={it.icon} size={16} /></span>{t(it.label)}</li>
        ))}
      </ul>
      <Button variant="white" to={TRAVEL_PROMO.to} icon={<Icon name="arrow-right" size={16} />}>{t(TRAVEL_PROMO.cta)}</Button>
      <img className="promo__art" src="/images/design/temple-line-art.webp" alt="" aria-hidden="true" />
    </div>
  );
}
